import ReactivateAccount from './reactivate-account';
export default ReactivateAccount;
